// extracted by mini-css-extract-plugin
module.exports = {"root":"l_pR","wrapper":"l_pS","image":"l_pT h_dq h_ds h_dQ","crop":"l_pV","round":"l_pW","fixedHeight":"l_pX"};